"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.cookiesPt = void 0;
var cookieBarPT_json_1 = __importDefault(require("./translation/cookieBarPT.json"));
var constants_1 = require("./constants");
exports.cookiesPt = {
    consent_modal: {
        title: cookieBarPT_json_1.default.consent_modal.text,
        description: cookieBarPT_json_1.default.consent_modal.description,
        primary_btn: {
            text: cookieBarPT_json_1.default.consent_modal.primaryButton,
            role: 'accept_all', // 'accept_selected' or 'accept_all'
        },
        secondary_btn: {
            text: cookieBarPT_json_1.default.consent_modal.secondaryButton,
            role: 'settings', // 'settings' or 'accept_necessary'
        },
    },
    settings_modal: {
        title: cookieBarPT_json_1.default.settings_modal.title,
        save_settings_btn: cookieBarPT_json_1.default.settings_modal.save_settings_btn,
        accept_all_btn: cookieBarPT_json_1.default.settings_modal.accept_all_btn,
        reject_all_btn: cookieBarPT_json_1.default.settings_modal.reject_all_btn,
        close_btn_label: cookieBarPT_json_1.default.settings_modal.close_btn_label,
        cookie_table_headers: [
            { col1: cookieBarPT_json_1.default.settings_modal.cookie_table_headers.col1 },
            { col2: cookieBarPT_json_1.default.settings_modal.cookie_table_headers.col2 },
            { col3: cookieBarPT_json_1.default.settings_modal.cookie_table_headers.col3 },
            { col4: cookieBarPT_json_1.default.settings_modal.cookie_table_headers.col4 },
            { col5: cookieBarPT_json_1.default.settings_modal.cookie_table_headers.col5 },
        ],
        blocks: [
            {
                title: cookieBarPT_json_1.default.settings_modal.blocks.usage.title,
                description: cookieBarPT_json_1.default.settings_modal.blocks.usage.description,
            },
            {
                title: cookieBarPT_json_1.default.settings_modal.blocks.necessary.title,
                description: cookieBarPT_json_1.default.settings_modal.blocks.necessary.description,
                toggle: {
                    value: 'necessary',
                    enabled: true,
                    readonly: true, // cookie categories with readonly=true are all treated as "necessary cookies"
                },
                cookie_table: [
                    {
                        col1: 'cc_cookie',
                        col2: constants_1.COOKIE_PROVIDER_MAIN_DOMAIN,
                        col3: "6 ".concat(cookieBarPT_json_1.default.months),
                        col4: cookieBarPT_json_1.default.firstParty,
                        col5: cookieBarPT_json_1.default.settings_modal.blocks.necessary.cookie_table.cc_cookie,
                    },
                    {
                        col1: 'sessionId, sessionId.sig',
                        col2: constants_1.COOKIE_PROVIDER_MAIN_DOMAIN,
                        col3: "1 ".concat(cookieBarPT_json_1.default.day),
                        col4: cookieBarPT_json_1.default.firstParty,
                        col5: cookieBarPT_json_1.default.settings_modal.blocks.necessary.cookie_table.sessionId,
                    },
                    {
                        col1: 'refreshSessionId, refreshSessionId.sig',
                        col2: constants_1.COOKIE_PROVIDER_MAIN_DOMAIN,
                        col3: "7 ".concat(cookieBarPT_json_1.default.days),
                        col4: cookieBarPT_json_1.default.firstParty,
                        col5: cookieBarPT_json_1.default.settings_modal.blocks.necessary.cookie_table.refreshSessionId,
                    },
                    {
                        col1: 'isLoggedIn, appLocale, userId, employeeCurrentHandledOffice, calendarView',
                        col2: constants_1.COOKIE_PROVIDER_MAIN_DOMAIN,
                        col3: 'N/A',
                        col4: cookieBarPT_json_1.default.localStorage,
                        col5: cookieBarPT_json_1.default.settings_modal.blocks.necessary.cookie_table.localStorage,
                    },
                    {
                        col1: '_grecaptcha',
                        col2: 'google.com',
                        col3: 'session',
                        col4: cookieBarPT_json_1.default.thirdParty,
                        col5: cookieBarPT_json_1.default.settings_modal.blocks.necessary.cookie_table.recaptcha,
                    },
                    {
                        col1: 'CONSENT',
                        col2: 'google.com',
                        col3: "2 ".concat(cookieBarPT_json_1.default.years),
                        col4: cookieBarPT_json_1.default.thirdParty,
                        col5: cookieBarPT_json_1.default.settings_modal.blocks.necessary.cookie_table.consent,
                    },
                    // Seznam.cz - mapy - https://o.seznam.cz/ochrana-udaju/personalizace-obsahu-a-reklamy/vyuzivani-cookies/
                    {
                        col1: 'sid',
                        col2: 'mapy.cz',
                        col3: "30 ".concat(cookieBarPT_json_1.default.days),
                        col4: cookieBarPT_json_1.default.thirdParty,
                        col5: cookieBarPT_json_1.default.settings_modal.blocks.necessary.cookie_table.mapy.sid,
                    },
                    {
                        col1: 'cmppersisttestcookie',
                        col2: 'mapy.cz',
                        col3: "730 ".concat(cookieBarPT_json_1.default.days),
                        col4: cookieBarPT_json_1.default.thirdParty,
                        col5: cookieBarPT_json_1.default.settings_modal.blocks.necessary.cookie_table.mapy.cmppersisttestcookie,
                    },
                    {
                        col1: 'szncmpone',
                        col2: 'mapy.cz',
                        col3: "13 ".concat(cookieBarPT_json_1.default.months),
                        col4: cookieBarPT_json_1.default.thirdParty,
                        col5: cookieBarPT_json_1.default.settings_modal.blocks.necessary.cookie_table.mapy.szncmpone,
                    },
                    {
                        col1: 'euconsent-v2',
                        col2: 'mapy.cz',
                        col3: "13 ".concat(cookieBarPT_json_1.default.months),
                        col4: cookieBarPT_json_1.default.thirdParty,
                        col5: cookieBarPT_json_1.default.settings_modal.blocks.necessary.cookie_table.mapy.euconsent,
                    },
                    {
                        col1: 'User-Id',
                        col2: 'mapy.cz',
                        col3: "1 ".concat(cookieBarPT_json_1.default.year),
                        col4: cookieBarPT_json_1.default.thirdParty,
                        col5: cookieBarPT_json_1.default.settings_modal.blocks.necessary.cookie_table.mapy.userId,
                    },
                    {
                        col1: 'lps',
                        col2: 'mapy.cz',
                        col3: "1 ".concat(cookieBarPT_json_1.default.year),
                        col4: cookieBarPT_json_1.default.thirdParty,
                        col5: cookieBarPT_json_1.default.settings_modal.blocks.necessary.cookie_table.mapy.lps,
                    },
                    {
                        col1: 'ps',
                        col2: 'mapy.cz',
                        col3: "2190 ".concat(cookieBarPT_json_1.default.days),
                        col4: cookieBarPT_json_1.default.thirdParty,
                        col5: cookieBarPT_json_1.default.settings_modal.blocks.necessary.cookie_table.mapy.ps,
                    },
                    {
                        col1: 'szncsr',
                        col2: 'mapy.cz',
                        col3: 'session',
                        col4: cookieBarPT_json_1.default.thirdParty,
                        col5: cookieBarPT_json_1.default.settings_modal.blocks.necessary.cookie_table.mapy.szncsr,
                    },
                ],
            },
            {
                title: cookieBarPT_json_1.default.settings_modal.blocks.analytics.title,
                description: cookieBarPT_json_1.default.settings_modal.blocks.analytics.description,
                toggle: {
                    value: 'analytics',
                    enabled: false,
                    readonly: false,
                },
                cookie_table: [
                    // list of all expected cookies
                    {
                        col1: '^_ga',
                        col2: 'google.com',
                        col3: "2 ".concat(cookieBarPT_json_1.default.years),
                        col4: cookieBarPT_json_1.default.thirdParty,
                        col5: cookieBarPT_json_1.default.settings_modal.blocks.analytics.cookie_table.ga,
                        is_regex: true,
                    },
                    {
                        col1: '_gid',
                        col2: 'google.com',
                        col3: 'session',
                        col4: cookieBarPT_json_1.default.thirdParty,
                        col5: cookieBarPT_json_1.default.settings_modal.blocks.analytics.cookie_table.gid,
                    },
                ],
            },
            {
                title: cookieBarPT_json_1.default.settings_modal.blocks.advertisement.title,
                description: cookieBarPT_json_1.default.settings_modal.blocks.advertisement.description,
                toggle: {
                    value: 'targeting',
                    enabled: false,
                    readonly: false,
                },
                cookie_table: [
                    {
                        col1: 'NID',
                        col2: 'google.com',
                        col3: "6 ".concat(cookieBarPT_json_1.default.months),
                        col4: cookieBarPT_json_1.default.thirdParty,
                        col5: cookieBarPT_json_1.default.settings_modal.blocks.advertisement.cookie_table.nid,
                    },
                    {
                        col1: '1P_JAR, DV',
                        col2: 'google.com',
                        col3: "1 ".concat(cookieBarPT_json_1.default.month),
                        col4: cookieBarPT_json_1.default.thirdParty,
                        col5: cookieBarPT_json_1.default.settings_modal.blocks.advertisement.cookie_table.dv,
                    },
                ],
            },
        ],
    },
};
